module.exports = __webpack_public_path__ + "img/3@2x.56bfbb9a.png";